import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectUserName } from '@ovpn-ui-toolkit/mf-common';

import { colors } from '@ovpn-ui/styles';
import { unlockScroll } from '@ovpn-ui/utils';
import { SidebarFooter, ProfileMenu } from '@ovpn-ui/navigation';

import useFooterLinks from './useFooterLinks';

const StyledSidebarFooter = styled(SidebarFooter)`
    .ovpn-avatar-label {
        overflow: hidden;

        .ovpn-avatar-title {
            overflow: hidden;

            white-space: nowrap;
            text-overflow: ellipsis;
        }

        .ovpn-avatar-description {
            color: ${colors.neutralBorder};
        }
    }
`;

export function AppSidebarFooter() {
    const username: string = useSelector(selectUserName);
    const { logout, role, links: userMenuLinks } = useFooterLinks();

    return (
        <StyledSidebarFooter>
            <ProfileMenu
                closeOnNavigate
                username={username}
                description={role.value}
                links={userMenuLinks}
                logoutLink={logout}
                onClick={unlockScroll}
            />
        </StyledSidebarFooter>
    );
}
